import React, { Component } from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import Button from 'common/components/Button';
import UserDetailsFormInputs from 'common/components/UserDetails/UserDetailsFormInputs';

import Form from 'core/forms/Form';

import { localeStrings as strings } from 'applicationConfig';

@observer
class UserDetailsForm extends Component {
  @observable disabled = true;

  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.toggleDisabled = this.toggleDisabled.bind(this);
  }

  onSubmit(e) {
    if (!this.disabled) {
      this.props.onSubmit(e).then(() => {
        this.disabled = true;
      });
    }

    return false;
  }

  toggleDisabled(e) {
    this.disabled = !this.disabled;

    return false;
  }

  render() {
    return (
      <div>
        <p>
          {this.disabled ? (
            strings.myAccount.userDetailsTab.captionAmend
          ) : (
            strings.myAccount.userDetailsTab.captionSubmit
          )}
        </p>
        <div className="user-details-form">
          <Form onSubmit={this.onSubmit} formStore={this.props.formStore}>
            <div className="user-details-fields">
              <UserDetailsFormInputs formStore={this.props.formStore} formLabels={this.props.formLabels} />

              <div className={`${this.disabled ? '' : 'hidden'} disabling-ovelay`} />
            </div>
            <div className="actions">
              {this.disabled && (
                <Button className="btn btn-primary" type="button" onClick={this.toggleDisabled}>
                  <span className="button-caption">{strings.generic.amend}</span>
                </Button>
              )}

              <Button
                className={`btn btn-primary ${this.disabled ? 'hidden' : ''}`}
                type="submit"
                disabled={!this.props.formStore.isValid}
              >
                <span className="button-caption">{strings.generic.submit}</span>
              </Button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}

export default UserDetailsForm;



// WEBPACK FOOTER //
// ./src/containers/MyAccount/UserDetails/UserDetailsForm.jsx